<template>
  <div class="flex gap-4">
    <NBadge label="Badge" />

    <NBadge class="rounded-full">
      4
    </NBadge>
  </div>
</template>
